<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Dashboard
        <small>Keywords</small>
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li>Dashboard</li>
        <li class="active">Keywords</li>
      </ol>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="row">
        <div class="col-md-12">
          <div class="box box-default">
            <div class="box-header with-border">
              <h3 class="box-title">Keywords</h3>

              <div class="box-tools pull-right">
                <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
                </button>
                <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button>
              </div>
            </div>
            <!-- /.box-header -->
            <div class="box-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="chart-responsive">
                    <chartjs-bar :datalabel="label" :labels="labels" :data="dataset" :bind="true"
                                 :backgroundcolor="bgcolors"></chartjs-bar>
                  </div>
                  <!-- ./chart-responsive -->
                </div>
              </div>
              <!-- /.row -->
            </div>
          </div>
        </div>
      </div>
      <!--Keyword Global funnel tables-->
      <div class="row">
        <div class="col-md-4">
          <div class="box box-default">
            <div class="box-header with-border">
              <h3 class="box-title">KEYWORD TABLES</h3>

              <div class="box-tools pull-right">
                <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i>
                </button>
                <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button>
              </div>
            </div>
            <!-- /.box-header -->
            <div class="box-body">
              <div class="row">
                <div class="col-md-12">
                  <h3 class="box-title">KEYWORD RECURRENCE</h3>
                  <table class="table table-bordered table-striped">
                    <thead>
                    <tr>
                      <th>Keyword</th>
                      <th>Recurrence</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(recurrence, keyword) in keywords" :key="keyword">
                      <td>{{ keyword }}</td>
                      <td>{{ recurrence }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <!-- /.row -->
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- /.content -->
  </div>
</template>

<script>
  import {
    getKeywords
  }
    from '../../../utils/stats'

  export default {
    name: 'app-keywords',
    data () {
      return {
        label: '#',
        labels: [],
        dataset: [],
        keywords: {},
        keywords_global: [],
        bgcolors: ['#0000FF', '#8A2BE2', '#A52A2A', '#DEB887', '#5F9EA0', '#7FFF00', '#D2691E', '#FF7F50', '#6495ED', '#FFF8DC', '#DC143C', '#00FFFF', '#00008B', '#008B8B', '#B8860B', '#A9A9A9', '#A9A9A9', '#006400', '#BDB76B', '#8B008B', '#556B2F', '#FF8C00', '#9932CC', '#8B0000', '#E9967A', '#8FBC8F', '#483D8B', '#2F4F4F', '#2F4F4F', '#00CED1', '#9400D3', '#FF1493', '#00BFFF', '#696969', '#696969', '#1E90FF', '#B22222', '#FFFAF0', '#228B22', '#FF00FF', '#DCDCDC', '#F8F8FF', '#FFD700', '#DAA520', '#808080', '#808080', '#008000', '#ADFF2F', '#F0FFF0', '#FF69B4', '#CD5C5C', '#4B0082', '#FFFFF0', '#F0E68C', '#E6E6FA', '#FFF0F5', '#7CFC00', '#FFFACD', '#ADD8E6', '#F08080', '#E0FFFF', '#FAFAD2', '#D3D3D3', '#D3D3D3', '#90EE90', '#FFB6C1', '#FFA07A', '#20B2AA', '#87CEFA', '#778899', '#778899', '#B0C4DE', '#FFFFE0', '#00FF00', '#32CD32', '#FAF0E6', '#FF00FF']
      }
    },
    mounted () {
      getKeywords().then((response) => {
        this.keywords = response.data.keywords
        for (let key in this.keywords) {
          if (this.keywords.hasOwnProperty(key)) {
            this.labels.push(key)
            this.dataset.push(this.keywords[key])
          }
        }
      }).catch(error => {
        console.log(error)
      })
    }
  }
</script>



// WEBPACK FOOTER //
// Keywords.vue?1e65dda0